import { httpDelete, httpGet, httpPost } from './api/axios_api';
import Constants from '../constants/constants';
import actions from './tournament_actions';

export async function getTournamentLeaderboardEntries(tournamentID, leaderboardType, page, daily) {
  const url = `${Constants.BACKEND_URL}/get-leaderboard-entries/${tournamentID}/${leaderboardType}/${page}/${daily}`;
  return httpGet(url, {});
}

export async function getActiveTournament() {
  const url = `${Constants.BACKEND_URL}/get-active-tournament`;
  return httpGet(url, {});
}

export function bulkDeleteTournaments(tournamentIds) {
  const url = `${Constants.BACKEND_URL}/tournaments/bulk-delete`;
  return httpPost(url, { tournamentIds: tournamentIds });
}

export function upsertTournament(tournament) {
  const url = `${Constants.BACKEND_URL}/tournaments/`;
  return httpPost(url, tournament);
}

export function getTournamentDates(value) {
  const url = `${Constants.BACKEND_URL}/tournaments/dates/`;
  return httpGet(url, { params: { business_group_id: value } });
}

export async function deleteTournament(tournamentId) {
  const url = `${Constants.BACKEND_URL}/tournaments/${tournamentId}`;
  return httpDelete(url, {});
}

export function getTournamentList(offset, limit, searchString, fromDate, toDate, createdBy) {
  // this is going to return a function
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/tournaments/`;

    return (
      httpGet(url, { params: { offset, limit, searchParams: searchString, fromDate, toDate, createdBy } })
        // then is a promise !!
        .then((response) => {
          if (typeof response !== 'undefined' && response.data.success) {
            const transmit_this = {
              type: actions.getTournamentList,
              data: {
                tournaments: response.data.tournaments,
                totalNumOfTournaments: response.data.totalNumOfTournaments,
                offset,
                limit,
                searchString,
              },
            };
            dispatch(transmit_this);
          }
        })
    );
  };
}

export function getTournamentBanners() {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/communications/tournament_banners`;
    return httpGet(url, {}).then((response) => {
      if (typeof response !== 'undefined' && response.data.success) {
        dispatch({
          type: actions.getTournamentBanners,
          data: {
            tournamentBanners: response.data.tournamentBanners,
          },
        });
      }
    });
  };
}

export function getTournamentCreators() {
  return (dispatch) => {
    const url = `${Constants.BACKEND_URL}/tournaments/creator`;
    return httpGet(url, {}).then((response) => {
      if (typeof response !== 'undefined' && response.data.success) {
        const remappedCreators = response.data.creators.map((creator) => {
          return {
            id: creator.Id,
            firstName: creator.firstName,
            lastName: creator.lastName,
          };
        });

        dispatch({
          type: actions.getTournamentCreators,
          data: {
            tournamentCreators: remappedCreators,
          },
        });
      }
    });
  };
}

const INITIAL_STATE = {
  tournaments: [],
  offset: 0,
  limit: 10,
  tournamentCreators: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.getTournamentList:
      return {
        ...state,
        ...action.data,
      };
    case actions.getTournamentBanners:
      return {
        ...state,
        ...action.data,
      };
    case actions.getTournamentCreators:
      return {
        ...state,
        ...action.data,
      };
    default:
      return { ...state };
  }
}
